

import { SubDomain } from "../SubDomain";
import Address from "./Address";

export default class AddressesDomain extends SubDomain {
    
  constructor(domain, storage) {
    super(domain, Address.MODEL_NAME);
    this.storage = storage;
  }
  
  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      var address = new Address(this.domain, item);
      if (address.id() === objId) {
        return new Address(this.domain, item);
      }
    }

    return new Address(this.domain).withId(objId);
  }
  
}